import { useState, useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import interceptor from "../lib/interceptor";
import { useLocation } from "react-router-dom";

const useVerifyPayment = () => {
  const [paymentData, setPaymentData] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  
  const params = new URLSearchParams(location.search);
  const authority = params.get("Authority");
  const status = params.get("Status");

  const verifyPayment = async ({ authority, status }) => {
    const response = await interceptor.get(`payment/mobile/api/v1/payment/verify/?Authority=${authority}&Status=${status}`);
    return response.data;
  };

  const { mutate, isLoading } = useMutation({
    mutationFn: verifyPayment,
    onSuccess: (data) => {
      setPaymentData(data);
      setError(null);
    },
    onError: (err) => {
      setError(err.message);
      console.log(err);
    }
  });

  useEffect(() => {
    if (authority && status) {
      mutate({ authority, status });
    }
  }, [authority, status]);

  return { paymentData, error, isLoading };
};

export default useVerifyPayment;
